import { TFiltersState } from "presentation/containers/context-api/ReportsFilterProvider";

export type TPanelProps = {
  panelId: number;
  htmlId: string;
  className: string;
  description: string;
  downloadOptions?: TDownloadOptions;
};

export type TDownloadOptions = {
  classToOverflow?: string[];
};

export type TFilterInfoProps = {
  experienceName: string;
  rangeName: string;
  deviceName: string;
};

const getExperienceName = (filterState: TFiltersState): string => {
  if (filterState.url?.value) return filterState.url.label;
  if (filterState.creative?.value) return filterState.creative.label;
  if (filterState.campaign?.value) return filterState.campaign.label;
  if (filterState.portfolio?.value) return filterState.portfolio.label;

  return "All";
};

const getRangeName = (filterState: TFiltersState): string => {
  if (filterState.ranges) {
    return filterState.ranges.label;
  }

  return `from ${filterState.startDate} to ${filterState.endDate}`;
};

const getDeviceName = (filterState: TFiltersState): string => {
  return filterState.devices?.label!;
};

export const LastFilterSelected = (
  filterState: TFiltersState
): TFilterInfoProps => {
  const experienceName = getExperienceName(filterState);
  const rangeName = getRangeName(filterState);
  const deviceName = getDeviceName(filterState);

  return {
    experienceName: experienceName,
    rangeName: rangeName,
    deviceName: deviceName,
  };
};

class Panel {
  constructor(
    panelId: number,
    htmlId: string,
    description: string,
    downloadOptions?: TDownloadOptions
  ) {
    this.panelId = panelId;
    this.htmlId = htmlId;
    this.className = "panel";
    this.description = description;
    this.downloadOptions = downloadOptions;
  }

  panelId: number;
  htmlId: string;
  className: string;
  description: string;
  downloadOptions: any;
}

const sortedTable = "sortedTable";

export const panelsInfo = {
  allPanels: new Panel(1, "allPanels", "All Panels"),
  highlights: new Panel(2, "highlights", "Highlights"),
  insightsOnTraffic: new Panel(3, "insightsOnTraffic", "Traffic insights"),
  dayParting: new Panel(4, "dayParting", "Users by time of day - GMT"),
  insightsOnTags: new Panel(5, "insightsOnTags", "Tags insights", {
    classToOverflow: [sortedTable],
  }),
  trafficSourceSummary: new Panel(
    6,
    "trafficSourceSummary",
    "Traffic source summary",
    { classToOverflow: [sortedTable] }
  ),
  dropoffCalculator: new Panel(7, "dropoffCalculator", "Drop-off calculator"),
  pageSummary: new Panel(8, "pageSummary", "Page summary", {
    classToOverflow: [sortedTable],
  }),
  creativeSummary: new Panel(9, "creativeSummary", "Creative summary", {
    classToOverflow: [sortedTable],
  }),
  campaignSummary: new Panel(10, "campaignSummary", "Campaign summary", {
    classToOverflow: [sortedTable],
  }),
  pageSpeed: new Panel(11, "pageSpeed", "Page speed", {
    classToOverflow: [sortedTable],
  }),
  topSummary: new Panel(12, "topSummary", "Console summary"),
  viewportRanking: new Panel(13, "viewportRanking", "Device summary"),
  creativeGoal: new Panel(14, "creativeGoal", "Goal tracking"),
};

export const formatedActualDate = () => {
  const currentDate = new Date();
  const month = currentDate.getMonth() + 1;
  const day = currentDate.getDate();
  const year = currentDate.getFullYear();

  return `${month.toString().padStart(2, "0")}_${day
    .toString()
    .padStart(2, "0")}_${year}`;
};
